






































































































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { List } from 'linqts'
import moment from "moment";

// Servicios
import { logService } from '@/services/LogService';
import { eventService } from "@/services/EventService";
import { toastService } from '@/services/ToastService';
import { EstadisticasService } from '@/services/EstadisticasService';
import { Sorteo } from '@/model/Sorteo';
import { EstadisticasGlobalesSorteo } from '@/model/EstadisticasGlobalesSorteo';
import { EstadisticaPersonalizada } from '@/model/EstadisticaPersonalizada';
import { EstadisticaPersonalizadaQuery } from '@/model/EstadisticaPersonalizadaQuery';

@Component({
  components: {
  },
})
export default class SorteoEstadisticaGlobales extends Vue {

  estadisticasService: any | EstadisticasService = new EstadisticasService();
  sorteo: any | Sorteo = {};

  estadisticaGlobalesSorteo: any | EstadisticasGlobalesSorteo = {};
  estadisticaPersonalizada: any | EstadisticaPersonalizada = {};
  estadisticaPersonalizadaQuery: any | EstadisticaPersonalizadaQuery = new EstadisticaPersonalizadaQuery();


  visibleGlobales: boolean = true;
  visiblePersonalizada: boolean = false;

  mounted(){
    
    eventService.on("SorteoDetailLoaded", (res: Sorteo) =>{
      this.sorteo = res;
      this.estadisticaPersonalizadaQuery.SorteoId = res.Id;
      this.loadEstadisticasGlobalesSorteo();
    });
  }

  destroyed(){
    eventService.off("SorteoDetailLoaded");
    this.sorteo = undefined;
  }

  loadEstadisticasGlobalesSorteo(){
    logService.Info("Inicio - Sorteo: "+this.sorteo.Id,"SorteoEstadisticaGlobales.vue - loadEstadisticasGlobalesSorteo()");
    eventService.emit("LoadPanel", true);
    this.estadisticasService.CalcularEstadisticasGlobalesSorteo(this.sorteo.Id).then((res: any) => {
      this.estadisticaGlobalesSorteo = res;
      eventService.emit("LoadPanel", false);
    })
  }

  loadEstadisticaPersonalizada(){
    logService.Info("Inicio - Sorteo: "+this.sorteo.Id,"SorteoEstadisticaGlobales.vue - loadEstadisticaPersonalizada()");
    eventService.emit("LoadPanel", true);
    this.estadisticasService.CalcularEstadisticaPersonalizada(this.estadisticaPersonalizadaQuery).then((res: any) => {
      this.estadisticaPersonalizada = res;
      this.visiblePersonalizada = true;
      eventService.emit("LoadPanel", false);
    })
  }

  setVisibleGlobales(){
    this.visibleGlobales = !this.visibleGlobales;
    logService.Info("Inicio - Sorteo: "+this.sorteo.Id+" - visibleGlobales: "+this.visibleGlobales,"SorteoEstadisticaGlobales.vue - setVisibleGlobales()");
  }

  reset(){
    this.estadisticaPersonalizadaQuery.PrimeraCifra = "";
    this.estadisticaPersonalizadaQuery.SegundaCifra = "";
    this.estadisticaPersonalizadaQuery.TerceraCifra = "";
    this.estadisticaPersonalizadaQuery.CuartaCifra = "";
    this.estadisticaPersonalizadaQuery.QuintaCifra = "";
  }
}
